import { createFeatureSelector } from '@ngrx/store';

import { billingFeatureName, BillingState } from '@billing/store/state/billing.state';

export const billingRootSelector = createFeatureSelector<BillingState>(billingFeatureName);
